import { useCallback } from 'react';
import { useNoticeBannersStackContext } from '@sweetgreen/garnish';

import { useRequestAccountDeletionMutation } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

export const useAccountDeletion = (props: UseAccountDeletionProps) => {
  const { onClose, onSuccess } = props;

  const { t } = useLocalizationContext();
  const { push: addNoticeBanner } = useNoticeBannersStackContext();

  const [deleteAccountResponse, deleteAccount] =
    useRequestAccountDeletionMutation();
  const isDeletingAccount = deleteAccountResponse.fetching;

  const requestAccountDeletion = useCallback(async () => {
    const { data } = await deleteAccount();
    const result = data?.requestAccountDeletion?.__typename;

    if (result !== 'RequestAccountDeletionSuccess') {
      addNoticeBanner({ text: t('account.delete.error'), palette: 'caution' });

      return;
    }

    addNoticeBanner({ text: t('account.delete.success'), palette: 'success' });
    onClose();
    onSuccess();
  }, [t, deleteAccount, addNoticeBanner, onClose, onSuccess]);

  return { isDeletingAccount, requestAccountDeletion };
};

type UseAccountDeletionProps = {
  readonly onSuccess: () => void;
  readonly onClose: () => void;
};
